<template>
  <div class="position-relative">
    <b-form-input
      v-bind="$attrs"
      :type="showPass ? 'text' : 'password'"
      :value="value"
      class="password-input"
      @input="$emit('input', $event)"
    />
    <i
      class="fas clickable-item password-input-toggle"
      :class="showPass ? 'fa-eye-slash' : 'fa-eye'"
      :title="showPass ? 'Hide password' : 'Show password'"
      @click.prevent="showPass = !showPass"
    />
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  inheritAttrs: false,

  props: {
    value: { type: String, default: '' },
  },

  data() {
    return {
      showPass: false,
    };
  },
};
</script>

<style scoped>
.password-input {
  padding-right: 2.5rem;
}

.password-input-toggle {
  position: absolute;
  top: 50%;
  right: 0.85rem;
  transform: translateY(-50%);
  color: #868e96;
}
</style>
